import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import LoadingGroup from './@shared/LoadingGroup';
import store from './redux/application';

// Polyfills for browser compatibility
(window as any).process = (window as any).process || { env: {} };

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <LoadingGroup>
        <App />
      </LoadingGroup>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
